module.exports = __webpack_public_path__ + "static/media/DateSelect.right.2a470dc0.png";